import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IProductos, IPromosEcommerce } from '../../../private/shared/models/productos';
import { CartProductsState } from '../../../store/reducers/ecommerce.reducer';
import { OperationsService } from '../../services/operations/operations.service';

const SummaryPriceDefault: ISummaryPriceCart = { total_cajas: 0, total_precio: 0, precio_descuento: 0 };

@Component({
  selector: 'app-add-cart',
  templateUrl: './add-cart.page.html',
  styleUrls: ['./add-cart.page.scss'],
})
export class AddCartPage implements OnInit, OnDestroy {

  @Input() addCart: Array<IProductos | IPromosEcommerce> = [];

  public summaryPriceCart: ISummaryPriceCart = SummaryPriceDefault;

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private operationsS: OperationsService
    , private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.operationsS.combinerCartOrder$()
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(this.callbackCartProducts);
  }

  ngOnDestroy() { }

  private callbackCartProducts = (resp: CartProductsState) => {
    const totalProducts = resp.cartProductos.concat(resp.cartPromos);
    this.summaryPriceCart = totalProducts.length < 1 ? SummaryPriceDefault :
      totalProducts.map(produc => ({
        total_cajas: produc.productos,
        total_precio: (produc.precio) * produc.productos,
        precio_descuento: (((produc.precio_original ? produc.precio_original : produc.precio) - produc.precio) * produc.productos) * -1
      }))
        .map(values => ({
          total_cajas: values.total_cajas,
          total_precio: this.operationsS.twoDecimal(values.total_precio),
          precio_descuento: this.operationsS.twoDecimal(values.precio_descuento),
        }))
        .reduce((a, b) => ({
          total_cajas: a.total_cajas + b.total_cajas,
          total_precio: a.total_precio + b.total_precio,
          precio_descuento: a.precio_descuento + b.precio_descuento
        }));
  }

  public onClose = () => this.modalCtrl.dismiss();

}

interface ISummaryPriceCart {
  total_cajas: number;
  total_precio: number;
  precio_descuento: number;
}
